import classnames from 'classnames';
import { isNone } from '../_util/defineType';
import Collapse from './collapse';
import Text from './text';
import Title from './title';
import './style/index';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const titleSizeMap = {
  h4: '20-24',
  h5: '18-20',
  h6: '16-20',
  h7: '14-18'
};
const Typography = props => {
  const {
    level = 'h5',
    title,
    checkbox,
    extra,
    info,
    help,
    subtitle,
    tips,
    children,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-typography");
  return /*#__PURE__*/_jsxs("div", {
    ...restProps,
    className: classnames(baseClassName, level, className),
    style: style,
    children: [!isNone(title) && /*#__PURE__*/_jsx(Title, {
      size: titleSizeMap[level],
      checkbox: checkbox,
      extra: extra,
      info: info,
      help: help,
      children: title
    }), !isNone(subtitle) && /*#__PURE__*/_jsx("div", {
      className: "".concat(baseClassName, "-subtitle"),
      children: subtitle
    }), !isNone(children) && /*#__PURE__*/_jsx("div", {
      className: "".concat(baseClassName, "-content"),
      children: children
    }), !isNone(tips) && /*#__PURE__*/_jsx("div", {
      className: "".concat(baseClassName, "-tips"),
      children: tips
    })]
  });
};
Typography.Title = Title;
Typography.Text = Text;
Typography.Collapse = Collapse;
export default Typography;